import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/App.css';
import './assets/css/styles.css';
import 'bootstrap/dist/js/bootstrap.min';

import MasterLayout from "./layouts/MasterLayout";

function App() {
  return (
    <Router>
          <Switch>
              <Route path="/" name="home" render={(props)=> <MasterLayout {...props} />} />
          </Switch>
      </Router>
  );
}

export default App;
